import qs from 'querystringify';
import eruda from 'eruda';
import $ from 'jquery';
import { methodType, unitMethod } from 'src/pages/buy-plan/components/other-cost/variable';
import { formatFloat } from '../pages/loan-calc/utils';
import { Envs, NativeCommonParams } from '../service/types';
import store from '../store';
import { envMap } from '../config';

export function getDeepValue(obj, path) {
  // 安全验证
  if (typeof obj !== 'object' || obj === null || !path || typeof path !== 'string') {
    return undefined;
  }

  const paths = path.split('.');
  const { length } = paths;

  // 递归结束, 返回目标结果
  if (length <= 1) {
    return obj[paths[0]];
  }

  // 路径未走完，继续递归
  if (paths[0] in obj) {
    return getDeepValue(obj[paths[0]], paths.slice(1, length).join('.'));
  }
}

export function delay(time = 1000, max = 10000) {
  time = parseInt(String(time));
  time = isNaN(time) ? 0 : time;
  time = Math.max(time, 0);
  time = Math.min(time, max);
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

export function getQueryParams() {
  return qs.parse(location.search.replace(/^\?/, '')) as Record<string, string>;
}

export function initGlobalStore(commonParams: NativeCommonParams) {
  const { orgCode, projectId, authToken, salt, app_code, sellerId, oppId, env, main_base_url } = commonParams;
  store.orgCode = orgCode;
  store.pid = projectId;
  store.authorization = authToken;
  store.salt = salt;
  store.app_code = app_code;
  store.sellerId = sellerId;
  store.oppId = oppId;
  store.env = envMap[env];
  store.main_base_url = main_base_url;
}

export function getEnvFromQuery(): Envs {
  const query = getQueryParams();
  const envStr = query.env || '4';
  return envMap[envStr] || Envs.PRO;
}

export const unitChange = (money: string | number, precision: number, unit: string) => {
  // precision保留小数点精度，+1是删掉小数点
  const moneyStr = money.toString();
  const del = precision ? precision + 1 : 0;
  const sliceMoney = moneyStr.toString().slice(0, moneyStr.length - del);

  // 去除小数点后，看位数是否过9位，是的话进行单位转换
  if (sliceMoney.length >= 9) {
    // 省略个十百千
    const resMoney = sliceMoney.slice(0, sliceMoney.length - 4);
    const resUnit = unit === '元' ? '万' : unit;
    return { resMoney, resUnit };
  } else {
    return { resMoney: money, resUnit: unit };
  }
};

/**
 * 1. 进行单位转化 2. 数字每三位用逗号隔开
 * @param money 数值
 * @param precision 小数点精度
 * @param unit 单位
 * @returns ｛转化后的数值， 转化后的单位｝
 */
export const handleMoney = (money: string | number, precision = 0, unit: string) => {
  // 只保留精度
  money = Number(money);
  money = formatFloat(money, precision);
  // 单位转换
  const { resMoney, resUnit } = unitChange(money, precision, unit);
  // 增加逗号分隔
  const realMoney = Number(resMoney).toLocaleString();
  return { realMoney, resUnit };
};

// 测试加载eruda
export const erudaInitTest = () => {
  const debugExpireTime = Number(localStorage.getItem('xsdj-debug-expire-time'));
  if (debugExpireTime && debugExpireTime > Date.now()) {
    eruda.init();
  }
};

// 连续触发n下 进入回调
export const createComboClickHandler = (callback, clickCount = 10) => {
  let clickCountTimer: any = null;
  let titleClickCount = 0;

  return () => {
    clearTimeout(clickCountTimer);

    if (++titleClickCount >= clickCount) {
      titleClickCount = 0;
      callback && callback(clickCount);
    }

    clickCountTimer = setTimeout(() => {
      titleClickCount = 0;
    }, 1000);
  };
};

// 连击n下设置debug开关
export const createDebugToggleHandler = (clickCount = 12, expireTime = Date.now() + 1000 * 60 * 60 * 12) =>
  createComboClickHandler(() => {
    // eslint-disable-next-line
    // @ts-ignore eruda的d.ts并没有声明这个属性
    const toggle = !eruda._isInit as boolean;
    if (toggle) {
      eruda.init();
    } else {
      eruda.destroy();
    }
    try {
      localStorage.setItem('xsdj-debug-expire-time', (toggle ? expireTime : 0).toString());
    } catch (err) {
      console.log(err);
    }
  }, clickCount);

export const phoneNumVerify = (phone: string) => /^1\d{10}$/.test(phone);

export const costUnit = (cost: string, method: string) => {
  switch (method) {
    case methodType[0]:
      return `${cost}${unitMethod[0]}`;
    case methodType[1]:
      return `${cost}${unitMethod[1]}`;
    case methodType[2]:
      return `${cost}${unitMethod[2]}`;
  }
};

export function templeteInjectParams(templete = '', paramsMap = {}) {
  templete = String(templete);
  if (!templete) {
    return templete;
  }
  const reg = /\${([^}]+)}/m; // 寻找 ${id} 结构
  for (;;) {
    const match = reg.exec(templete);
    if (!match) {
      break;
    }
    templete = templete.replace(match[0], getDeepValue(paramsMap, match[1]) || '');
  }
  return templete;
}

export const handleResourceUrl = (function () {
  const map = {};
  function fn(url) {
    return templeteInjectParams(url, map);
  }

  fn.setParams = function (params) {
    Object.assign(map, params);
  };

  return fn;
})();

export function debounce(fn, time = 300, context = null, parseValue = false) {
  if (typeof fn !== 'function') {
    console.error('fn必须是函数!');
    return;
  }
  const _args = Array.prototype.slice.call(arguments, 3, arguments.length); // 构造时传来的参数
  let timer: number | null = null;
  return function (e) {
    const __args = Array.prototype.slice.call(arguments, 0); // 实际触发时传来的参数
    if (parseValue && typeof e === 'object' && 'target' in e && 'value' in e.target) {
      // 解析事件对象
      __args.splice(0, 0, e.target.value);
    }
    const args = _args.concat(__args); // 最终参数
    timer && window.clearTimeout(timer);
    timer = window.setTimeout(fn.bind(context, ...args), time);
  };
}

// 转换style对象中的长度, 图片url
export function convertStyle(styleObj, params = {}) {
  const { referWidth, referHeight, width, noConvertNumber } = params as any;
  if (!styleObj) return styleObj;
  if (!noConvertNumber && (!referWidth || !referHeight || !width)) return styleObj;

  const reRawNum = /opacity|font|zIndex/;
  const reRes = /\$\{resource\}/;
  const reUrl = /url\(.*\)/i;
  const scale = width / referWidth;
  const newStyle = {};
  Object.keys(styleObj).forEach((key) => {
    const value = styleObj[key];
    if (reRawNum.test(key)) {
      newStyle[key] = value;
    } else if (!noConvertNumber && typeof value === 'number') {
      newStyle[key] = value * scale;
    } else if (reRes.test(value)) {
      newStyle[key] = reUrl.test(value) ? handleResourceUrl(value) : `url(${handleResourceUrl(value)})`;
    } else {
      newStyle[key] = value;
    }
  });

  return newStyle;
}

export class YKScroll {
  _element: any;
  _targetValue: any;
  _scrolling: boolean;
  _directionFieldsMap: any;

  constructor(options: any = {}) {
    this._element = options.element;
    this._targetValue = 0;
    this._scrolling = false;
    this._directionFieldsMap = {
      h: {
        scrollSize: 'scrollWidth',
        clientSize: 'clientWidth',
        scrollValue: 'scrollLeft',
        positionValue: 'left',
        offsetValue: 'offsetLeft',
      },
      v: {
        scrollSize: 'scrollHeight',
        clientSize: 'clientHeight',
        scrollValue: 'scrollTop',
        positionValue: 'top',
        offsetValue: 'offsetTop',
      },
    };
  }

  get element() {
    return typeof this._element === 'function' ? this._element() : this._element;
  }

  /**
   * scrollTo 基于RAF的动画滚动
   * @param {number|string} targetValue 数字时为具体滚动位置， 字符串时作为selector查询滚动位置
   * @param {number} speed
   * @param {string} direction // v: 垂直, h: 水平
   */
  scrollTo = (target, speed = 10, direction = 'v') => {
    const el = this.element;
    if (!(el instanceof HTMLElement)) {
      return;
    }
    direction = direction === 'h' ? 'h' : 'v';
    const clientSize = this._directionFieldsMap[direction].clientSize;
    const offsetValue = this._directionFieldsMap[direction].offsetValue;

    let targetValue = 0;
    switch (typeof target) {
      case 'number': {
        if (isNaN(target)) {
          return;
        }
        targetValue = target;
        break;
      }
      case 'string': {
        let focusEl;
        try {
          focusEl = document.querySelector(target) as any;
        } catch {
          focusEl = $(target);
        }
        if (!focusEl) return;
        if (focusEl.length < 1) {
          return;
        } else {
          // 滚动到视窗
          const itemValue = focusEl[offsetValue];
          const containerSize = el[clientSize];
          const itemSize = focusEl[clientSize];
          targetValue = itemValue - (containerSize - itemSize) / 2;
        }
        break;
      }
      default: {
        return;
      }
    }

    el.scrollTo({
      [direction === 'h' ? 'left' : 'top']: targetValue,
      behavior: 'smooth',
    });
  };
}

// 原生方法可以使用MOCK数据
export const NATIVE_MOCK = /true/i.test(process.env.NATIVE_MOCK as any);

export const getResourceURLFromLocation = () => {
  const lastIndex = location.pathname.lastIndexOf('/');
  const pathname = location.pathname.slice(0, lastIndex);
  return `${location.origin}${pathname}`;
};

export const convertToNumber = (input: any) => (Number.isNaN(Number(input)) ? 0 : Number(input));
